"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContainer = void 0;
const react_1 = __importDefault(require("react"));
const ToastContainer = ({ children }) => {
    return (react_1.default.createElement("div", { "aria-live": "assertive", className: "pointer-events-none z-[1000] fixed inset-0 flex items-start px-8 py-6 pt-[5rem]" },
        react_1.default.createElement("div", { className: "flex w-full flex-col items-center space-y-4 sm:items-end" }, children)));
};
exports.ToastContainer = ToastContainer;
//# sourceMappingURL=ToastContainer.js.map